<template>
  <div class="flex animate-pulse items-start gap-3 rounded-2xl border border-main bg-surface p-4" data-testid="notification-card-skeleton">
    <div class="size-10 shrink-0 rounded-full bg-surface-elevation-2" />
    <div class="flex min-w-0 grow flex-col gap-1.5">
      <div class="flex flex-wrap items-center gap-2">
        <div class="h-5 w-16 rounded-full bg-surface-elevation-2" />
        <div class="h-5 w-12 rounded-full bg-surface-elevation-2" />
      </div>
      <div class="h-4 w-3/4 rounded-sm bg-surface-elevation-2" />
      <div class="h-3 w-1/2 rounded-sm bg-surface-elevation-2" />
      <div class="mt-0.5 h-4 w-20 rounded-sm bg-surface-elevation-2" />
    </div>
    <div class="flex shrink-0 flex-col items-end justify-between gap-3 self-stretch">
      <div class="flex items-center gap-1">
        <div class="size-8 rounded-sm bg-surface-elevation-2" data-testid="notification-card-skeleton-action" />
        <div v-if="!singleAction" class="size-8 rounded-sm bg-surface-elevation-2" data-testid="notification-card-skeleton-action" />
      </div>
      <div class="h-3 w-16 rounded-sm bg-surface-elevation-2" />
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ singleAction?: boolean }>(), { singleAction: false })
</script>
